<script setup>

// Props
const props = defineProps({
  logoGardenImages: {
    type: Array,
    default: () => []
  }
})

</script>

<!-- -------------------------------------------------------------------------------------------------
    Template
------------------------------------------------------------------------------------------------- -->

<!-- Static logo grid: 3 columns on mobile, 4 on tablet, 6 (two rows of the design) on desktop -->
<template>
<ul v-if="logoGardenImages?.length"
  class="logo-garden-static"
  aria-label="Customer logos">
  <li v-for="image in logoGardenImages"
    :key="image.id"
    class="logo-garden-static__item">
    <GlobalsImage
      :image="image"
      :alt="image.alt || image.title || 'Company logo'"
      :quality="70"
    />
  </li>
</ul>
</template>

<!-- -------------------------------------------------------------------------------------------------
    Styling
------------------------------------------------------------------------------------------------- -->

<style scoped>

.logo-garden-static {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  row-gap: 13px;
  max-width: 315px;
  margin: 0 auto;
  padding: 0;
  list-style: none;

  @media (min-width: 768px) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    row-gap: 24px;
    max-width: 720px;
  }

  @media (min-width: 1024px) {
    grid-template-columns: repeat(6, minmax(0, 1fr));
    row-gap: 40px;
    max-width: 1490px;
  }
}

.logo-garden-static__item {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 26px;
  margin: 0;

  @media (min-width: 768px) {
    height: 45px;
  }

  @media (min-width: 1024px) {
    height: 62px;
  }
}

/* Logo files carry their own padding (as the Figma frames do), so they fill the cell */
.logo-garden-static__item :deep(picture) {
  display: contents;
}

.logo-garden-static__item :deep(img) {
  display: block;
  width: auto;
  max-width: 100%;
  height: 100%;
  object-fit: contain;
}

</style>


<style>

.hero-carousel + .logo-garden-carousel.--static {
  margin-top: calc(50px - 26px);
  margin-bottom: 50px;

  @media (min-width: 1024px) {
    margin-top: calc(100px - 30px);
    margin-bottom: 100px;
  }

  @media (min-width: 1440px) {
    margin-top: calc(160px - 30px);
    margin-bottom: 160px;
  }
}

</style>